/**
 * Single source of truth for the ESRI demographic data vintage.
 *
 * ESRI serves age/population data under vintage-agnostic keys (`current`,
 * `future`, `2020`), so calculations update automatically when the underlying
 * data is refreshed. These constants only drive the human-readable YEAR LABELS
 * shown in charts, cards, tooltips, exports, and copy. Update them here when the
 * ESRI vintage is refreshed and every label follows.
 *
 * NOTE: These are ESRI-only. NCES enrollment years (e.g. "2019-20"/"2024-25")
 * and NCES-based enrollment projections are a separate dataset and are NOT
 * governed by these values.
 */
export const ESRI_DATA_VINTAGE = {
  census: 2020,
  current: 2026,
  projection: 2031,
};

export const ESRI_CENSUS_YEAR = ESRI_DATA_VINTAGE.census; // 2020
export const ESRI_CURRENT_YEAR = ESRI_DATA_VINTAGE.current; // 2026
export const ESRI_PROJECTION_YEAR = ESRI_DATA_VINTAGE.projection; // 2031

/**
 * When the current ESRI vintage was last refreshed (human-readable). Update this
 * alongside the year constants above at each ESRI refresh.
 */
export const ESRI_LAST_UPDATED = 'July 2026';

/**
 * Short, user-facing note explaining the ESRI data recency. Shown near ESRI-derived
 * figures (AI summaries, Geographic/Competitive explorers) so users can connect the
 * numbers to when the demographic data was last updated. Intentionally does NOT
 * claim any prior figures were wrong — it only states the current vintage.
 */
export const ESRI_UPDATE_NOTE =
  `ESRI demographic data was last updated ${ESRI_LAST_UPDATED}: current-year figures reflect ` +
  `${ESRI_CURRENT_YEAR} estimates, with 5-year projections through ${ESRI_PROJECTION_YEAR}.`;
